<template>
  <div class="stepOneMain">
    <div class="scroll_wrap">
      <vue-scroll ref="scroll">
        <el-form
          ref="plainInfo"
          :model="plainInfo"
          :rules="formRules"
          label-width="180px"
          class="black_form"
        >

          <el-form-item label="赛事性质" prop="matchType">
            <el-select
                v-model="plainInfo.matchType"
                placeholder="请选择赛事性质"
                class="w445"
            >
              <el-option
                  v-for="(item, index) in matchTypeList"
                  :key="index"
                  :label="item"
                  :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否高水平赛事"  class="yioks-switch-grey">
            <el-switch
              v-model="plainInfo.highLevel"
              active-text="是"
              inactive-text="否"
              active-color="#13ce66"
              inactive-color="#ccc"
              @change="changeSwitch"
            ></el-switch>
            <span style="margin-left:20px">提示：高水平赛事为市级及以上青少年赛事</span>
          </el-form-item>
          <template v-if="plainInfo.highLevel">
            <el-form-item label="高水平赛事" prop="recordUuid">
              <el-select
                v-model="plainInfo.recordUuid"
                placeholder="请选择赛事"
                class="w445"
                @change="getRecordInfo"
              >
                <el-option
                  v-for="(item,index) in recordList"
                  :key="index"
                  :label="item.recordName"
                  :value="item.uuid" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="高水平赛事类型" prop="squadSex">
              <el-select
                v-model="plainInfo.squadSex"
                placeholder="请选择赛事类型"
                class="w445"
                @change="changeSquadType(plainInfo.squadSex,true)"
              >
                <el-option
                  v-for="(item,index) in squadType"
                  :key="index"
                  :label="item.sex"
                  :value="item.value" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="高水平赛事球队分组" prop="squadLevel">
              <el-select
                v-model="plainInfo.squadLevel"
                placeholder="请选择高水平赛事球队分组"
                class="w445"
              >
                <el-option
                  v-for="(item, index) in squadLevelList"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>

          <el-form-item label="赛事名称" prop="tournamentName">
            <el-input
                v-model="plainInfo.tournamentName"
                class="w445"
                placeholder="请输入赛事名称"
                maxlength="100"
              :disabled="plainInfo.recordUuid ? true : false"
                show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="机构参赛球队名称" prop="squadNowName">
            <el-input
              v-model="plainInfo.squadNowName"
              class="w445"
              placeholder="请输入机构参赛球队名称"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="赛事地点" prop="tournamentPlace">
            <el-input
                v-model="plainInfo.tournamentPlace"
                class="w445"
                placeholder="请输入赛事地点"
                maxlength="100"
                show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="赛事开始时间" prop="matchTime">
            <el-date-picker
              v-model="plainInfo.matchTime"
              class="w445"
              type="date"
              placeholder="请选择赛事开始时间"
              value-format="timestamp"
              :editable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="赛事结束时间" prop="endTime">
            <el-date-picker
              v-model="plainInfo.endTime"
              class="w445"
              type="date"
              placeholder="请选择赛事结束时间"
              value-format="timestamp"
              :editable="false"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="赛事结果" prop="squadResult">
            <el-select
              v-model="plainInfo.squadResult"
              class="w445"
              placeholder="请选择赛事结果"
            >
              <el-option
                v-for="(item, index) in matchResultList"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛事秩序册文件" :error="uploadErroeMsg" >
            <el-upload
              class="yioks-form-item"
              :action="uploadPath"
              :on-remove="handleRemoveFile"
              :before-upload="beforeUpload"
              :on-success="handleSuccessFiler"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="uploadFileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <a>单个上传文件大小不能超过50M,最多上传1个文件。</a>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="成绩公告文件" :error="uploadErroeMsg" >
            <el-upload
              class="yioks-form-item"
              :action="uploadPath"
              :on-remove="handleRemoveFileScore"
              :before-upload="beforeUpload"
              :on-success="handleSuccessFilerScore"
              multiple
              :limit="1"
              :on-exceed="handleExceed"
              :file-list="uploadFileListScore"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <a>单个上传文件大小不能超过50M,最多上传1个文件。</a>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item label="赛事总体描述">
            <quill-editor
              v-model="plainInfo.tournamentEvalComment"
              class="simple_editor"
              :options="editorOption"
            ></quill-editor>
          </el-form-item>
          <!--<el-form-item label="赛事总体描述" prop="tournamentEvalComment">-->
            <!--<el-input-->
              <!--v-model="plainInfo.tournamentEvalComment"-->
              <!--class="w445"-->
              <!--placeholder="请输入赛事总体描述"-->
              <!--maxlength="500"-->
              <!--show-word-limit-->
              <!--type="textarea"-->
              <!--:rows="2"-->
            <!--&gt;</el-input>-->
          <!--</el-form-item>-->



          <!-- ================================= -->
        </el-form>
      </vue-scroll>
    </div>
    <div class="next_btn_wrap">
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        @click="saveData('temporarily')"
        >暂时保存</el-button
      >
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        :loading="saveBtn"
        @click="saveData('next')"
        >下一步</el-button
      >
      <el-button type="danger" @click="showTip = true">取消</el-button>
    </div>
    <yioks-tip
      :showTip="showTip"
      :tipMsg="$t('waivedSubmission')"
      @callback="goBack"
    ></yioks-tip>
    <yioks-tip
      :showTip="temporarily"
      :tipMsg="tips"
      @callback="saveTemporarily"
    ></yioks-tip>
    <yioks-tip
      :showTip="confirmSubmit"
      :tipMsg="confirmTips"
      @callback="confirmSave"
    ></yioks-tip>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; // 富文本编辑器，下面的样式必须引入
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import common from "@/api/common";
import match from "@/api/match";
import record from "@/api/record";
import storage from "@/utils/storage";
export default {
  components: {
    quillEditor,
    Pagination: () => import("@/components/Pagination"),
    "yioks-sspviewer": () => import("@/components/sspViewer/sppCanvas"),
    FlashTips: () => import("@/components/FlashTips"),
  },
  data() {
    return {
      // 表单信息
      tips: "确定暂时保存并返回吗?",
      confirmSubmit: false, // 确认提交
      confirmTips: "确定保存并进入下一步吗?",
      plainInfo: {
        matchType: "", // 赛事性质
        tournamentName: "", // 赛事名称
        squadNowName: "", // 机构参赛名称
        tournamentPlace: "", // 赛事地点
        matchTime: "", // 开场时间
        endTime: "", // 开场时间
        squadResult: "", // 赛事结果
        squadLevel: "",
        squadSex: "",
        highLevel: "否",
        fileUrl: "", // 文件路径
        fileName: "", // 文件名
        recordUuid:'',
        tournamentEvalComment:'',
        // overallEvalComment: "", // 训练总体描述
      },
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileListScore: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      // 表单验证规则
      formRules: {
        matchType: [{ required: true, message: "请选择赛事性质", trigger: "change" }],
        tournamentName: [{ required: true, message: "请输入赛事名称", trigger: "blur" }],
        squadNowName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        tournamentPlace: [{ required: true, message: "请输入赛事地点", trigger: "blur" }],
        matchTime: [{ required: true, message: "请选择开始时间", trigger: "change" },],
        endTime: [{ required: true, message: "请选择结束时间", trigger: "change" },],
        matchTotalTime: [{ required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入赛事时长'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的赛事时长'))
              }
            }
          },
          trigger: 'blur' }],
        weather: [{ required: true, message: "请选择赛事天气", trigger: "change" },],
        teamFormation: [{ required: true, message: "请选择主要阵型", trigger: "change" },],
        squadResult: [{ required: true, message: "请选择赛事结果", trigger: "change" },],
        squadLevel: [{ required: true, message: "请选择", trigger: "change" },],
        squadSex: [{ required: true, message: "请选择", trigger: "change" },],
        recordUuid: [{ required: true, message: "请选择", trigger: "change" },],
        goalScore: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入进球数'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的进球数'))
              }
            }
          },
          trigger: 'blur'
        }],
        goalConceded: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入失球数'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的失球数'))
              }
            }
          },
          trigger: 'blur'
        }],
      },

      // 赛事性质
      matchTypeList: ["友谊赛", "锦标赛", "联赛", "国际赛事"],
      // 赛事结果
      matchResultList: Array.from({ length: 32 }, (_, i) => ({
        name: `第${i + 1}名`,
        value: `${i + 1}`
      })),
      // vue-edit 设置，只需要三个
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
          ],
        },
        placeholder: this.$t("defaultPlaceholder"),
      },
      userRole: storage.get("userInfo").userRole, // 登录角色
      idx: 0, // 第几个环节
      showTip: false, // 取消提示
      squadUuid: this.$route.query.squadUuid,
      squadInfo: {}, // 球队的详情
      temporarily: false, // 暂时保存提示
      data: "", // 需要保存的数据
      tournamentUuid : this.$route.query.uuid,
      saveBtn: false, // 下一步按钮 loading
      squadLevelList:[],
      squadLevelMale:[],
      squadLevelFemale:[],
      squadLevelMixed:[],
      squadType:[],
      squadLevel:[],
      recordList:[],
      recordToScoreList: [], // 配置得分
      recordToSquadList: [], // 配置球队

    };
  },

  computed: {
  },

  watch: {
  },
  created() {
    this.getCommon();
    this.getRecordMatchAll();
    if (this.tournamentUuid ) this.getMatchReportInfo();
  },
  methods: {
    getRecordMatchAll(){
      record.getRecordMatchAll('2025').then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordList=res;
      }).catch(err => {
        console.error(err)
      })
    },
    getRecordInfo() {
      record.getRecordInfo(this.plainInfo.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.squadLevelMale = [];
        this.squadLevelFemale = [];
        this.squadLevelMixed = [];
        this.squadType = [];

        this.plainInfo.tournamentName = res.recordName;
        this.recordToScoreList = res.recordToScoreList;
        this.recordToSquadList = res.recordToSquadList;
        let tmp =[];
        this.recordToSquadList.map(item => { // 获取球队类型
          let tmpMap = {};
          if (tmp.indexOf(item.squadSex) === -1) {
            tmpMap.sex = item.squadSex === "male" ? "男足" : item.squadSex === "mixed" ? "与其他单位球员联合组队" : "女足";
            tmpMap.value = item.squadSex;
            tmp.push(item.squadSex);
            this.squadType.push(tmpMap);
          }

          if(item.squadSex === "male"){
            this.squadLevelMale.push(item.squadLevel);
          }
          if(item.squadSex === "female"){
            this.squadLevelFemale.push(item.squadLevel);
          }
          if(item.squadSex === "mixed"){
            this.squadLevelMixed.push(item.squadLevel);
          }
        })
        this.changeSquadType(this.plainInfo.squadSex,false);
      }).catch(err => {
        console.error(err)
      })
    },
    changeSwitch(){
      this.$refs['plainInfo'].clearValidate();
      if(!this.plainInfo.highLevel){
        this.plainInfo.squadLevel = '';
        this.plainInfo.recordUuid = '';
        this.plainInfo.squadSex = '';
        this.plainInfo.tournamentName = '';
      }

    },

    changeSquadType(type,change){
      if(change){
        this.plainInfo.squadLevel = '';
      }
      if(type === "male"){
        this.squadLevelList = this.squadLevelMale;
      }
      if(type === "female"){
        this.squadLevelList = this.squadLevelFemale;
      }
      if(type === "mixed"){
        this.squadLevelList = this.squadLevelMixed;
      }
    },
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    handleRemoveFileScore(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        this.uploadFileListScore = this.uploadFileListScore.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileListScore = this.uploadFileListScore.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },
    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传1个文件，请删除后再次上传。`);
    },
    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
      this.uploadFileList.push(fileObj);
    },
    //  证明材料提交成功
    handleSuccessFilerScore(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
      this.uploadFileListScore.push(fileObj);
    },
    // 上传文件检测
    beforeUpload(file) {
      const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i
      const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
        return false;
      }
      if (!fileType) {
        this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件");
        return false;
      }
      return fileLimit;
    },
    // 教案列表 - 获取球队
    getCommon() {
      if (this.squadUuid) {
        common.getSquadInfo(this.squadUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.squadInfo = res.squad;
          }
        });
      }
    },
    // 当存在 tournamentUuid  存在时，代表编辑，请求回显数据
    getMatchReportInfo() {
      match.matchTournamentInfo(this.tournamentUuid ).then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          this.$router.push("/home/index");
        } else {
          this.squadUuid = res.squadUuid; // 球队uuid
          this.plainInfo.matchType = res.matchType; //赛事性质
          this.plainInfo.tournamentName = res.tournamentName;//赛事名称
          this.plainInfo.squadNowName = res.squadNowName;
          this.plainInfo.tournamentEvalComment = res.tournamentEvalComment;
          this.plainInfo.tournamentPlace = res.tournamentPlace;//赛事地点
          this.plainInfo.squadLevel = res.squadLevel;//赛事地点
          this.plainInfo.squadSex = res.squadSex;//赛事地点
          this.plainInfo.squadResult = res.squadResult;//赛事地点
          this.plainInfo.recordUuid = res.recordUuid;
          this.plainInfo.matchTime = res.matchTime;//赛事开始时间
          this.plainInfo.endTime = res.endTime;//赛事开始时间
          this.plainInfo.highLevel = res.highLevel;
          this.plainInfo.organShortName = this.squadInfo.organShortName;
          this.plainInfo.organUuid = this.squadInfo.organUuid;
          this.plainInfo.youthUuid = this.squadInfo.youthUuid;
          this.plainInfo.youthShortName = this.squadInfo.youthShortName;

          if(res.fileUrl){
            const fileObj = {
              name: res.fileName,
              url: res.fileUrl,
              fileName: res.fileName,
              fileUrl: res.fileUrl
            };
            this.uploadFileList.push(fileObj);
          }

          if(res.fileUrlScore){
            const fileObj = {
              name: res.fileNameScore,
              url: res.fileUrlScore,
              fileName: res.fileNameScore,
              fileUrl: res.fileUrlScore
            };
            this.uploadFileListScore.push(fileObj);
          }

          if(this.plainInfo.recordUuid){
            this.getRecordInfo();
          }
        }
      });
    },
    // 球队信息
    // 返回
    goBack(isShow) {
      if (isShow) {
        this.$router.go(-1);
      }
      this.showTip = false;
    },
    // 下一步，保存数据
    saveData(val) {
      if(this.uploadFileList.length === 0){
        this.$message.error("请检查赛事秩序册文件是否上传。");
        return
      }
      if(this.uploadFileListScore.length === 0){
        this.$message.error("请检查成绩公告文件是否上传。");
        return
      }
      this.$refs["plainInfo"].validate((valid) => {
        if (valid) {
          this.data = {
            organShortName: this.squadInfo.organShortName,// 会员协会简称
            organUuid: this.squadInfo.organUuid,// 会员协会uuid
            youthUuid: this.squadInfo.youthUuid,// 青训机构uuid
            youthShortName: this.squadInfo.youthShortName,// 青训机构简称
            squadUuid: this.squadUuid,// 球队uuid
            matchType:this.plainInfo.matchType,//赛事性质
            tournamentName:this.plainInfo.tournamentName,//赛事名称
            squadNowName:this.plainInfo.squadNowName,//赛事名称
            tournamentPlace:this.plainInfo.tournamentPlace,//赛事地点
            squadLevel:this.plainInfo.squadLevel,
            tournamentEvalComment:this.plainInfo.tournamentEvalComment,
            squadSex:this.plainInfo.squadSex,//赛事地点
            squadResult:this.plainInfo.squadResult,//赛事地点
            recordUuid:this.plainInfo.recordUuid,
            matchTime:this.plainInfo.matchTime,//赛事开始时间
            endTime:this.plainInfo.endTime,//赛事开始时间
            highLevel:this.plainInfo.highLevel,
            uuid: this.tournamentUuid ,
            fileUrl: this.uploadFileList.length > 0 ? this.uploadFileList[0].fileUrl : "",
            fileName: this.uploadFileList.length > 0 ? this.uploadFileList[0].fileName : "",
            fileUrlScore: this.uploadFileListScore.length > 0 ? this.uploadFileListScore[0].fileUrl : "",
            fileNameScore: this.uploadFileListScore.length > 0 ? this.uploadFileListScore[0].fileName : "",
          }
          if (val === "temporarily") {
            this.temporarily = true;
          } else {
            this.saveBtn = true;
            this.confirmSubmit = true;
          }
        }
      });
    },
    // 暂时保存并返回列表
    saveTemporarily(isSure) {
      if (isSure) {
        match.FirstMatchReportTournament(this.data).then((res) => {
          this.$router.go(-1);
        });
      } else {
        this.temporarily = false;
      }
    },
    // 确定保存并返回列表
    confirmSave(isSure) {
      if (isSure) {
        match.FirstMatchReportTournament(this.data).then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              this.saveBtn = false;
              this.confirmSubmit = false;
            } else {
              this.saveBtn = false;
              this.confirmSubmit = false;
              this.$emit("changeNav", {
                jump: 1,
                uuid: res.uuid,
                tournamentReportStatus: res.tournamentReportStatus,
                squadUuid: this.squadUuid,
              });
            }
          })
          .catch((err) => {
            this.confirmSubmit = false;
            this.saveBtn = false;
          });
      } else {
        this.confirmSubmit = false;
        this.saveBtn = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.stepOneMain
  display flex
  justify-content space-between
  flex-direction column
  height 590px
  .scroll_wrap
    height 540px
    padding 20px 10px
    background-color $black_color
    overflow hidden
    .w445
      width: 445px;
    .w150
      width: 150px;
    .link_item
      margin-right 20px
      .line
        margin-right 0
      .link_title
        display flex
        align-items center
        font-size 20px
        margin-bottom 20px
        margin-left 20px
        img
          width 28px
          height 28px
          margin-right 20px
      .info_wrap
        display flex
        .img_wrap
          position relative
          margin-left 20px
          height 100px
          img
            width 170px
            height 100px
          .detail
            background #FFF
            width 80px
            height 30px
            border-radius 5px
            color #999
            font-size 16px
            line-height 30px
            text-align center
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            cursor pointer
      .slider
        width 445px
        position relative
        .time
          position absolute
          font-size 16px
          right -50px
          top -5px
  .tutorial_wrap
    height 590px
    display flex
    flex-direction column
    .search_wrap
      display flex
      border-bottom 1px solid #DDD
      padding 20px 0
      margin 0 20px 10px
    .tutorial
      flex 1
      overflow hidden
      color #999
      font-size 16px
      .item
        padding 10px 0
        border-bottom 1px solid #CCC
        margin 0 20px
        .title
          padding 10px 0 25px 0
          font-size 20px
          font-weight bold
          color #000
        .info_content
          display flex
          img
            width 207px
            height 121px
            margin-right 25px
          .info
            display flex
            flex-direction column
            justify-content center
            flex 1
            p
              margin-bottom 10px
          .btn_wrap
            margin-right 40px
            .btn
              background $green_color2
              color #FFF
              height 40px
              text-align center
              line-height 40px
              margin 20px auto 0
              cursor pointer
  .detail_wrap
    padding 20px
    padding-right 0
    height 560px
    overflow hidden
    .title
      font-size 22px
      padding-bottom 20px
      margin-right 20px
      border-bottom 1px solid #DDD
    .detail
      display flex
      margin-right 20px
      .tutorial_wrap
        width 340px
        height 203px
        position relative
        .tutorial, .tutorial_img
          position absolute
          left 0
          top 0
          z-index 2
        .tutorial_img
          z-index 1
          width 336px
          height 198px
          top 4px
      .info
        font-size 18px
        padding 20px 0 0 20px
        p
          margin-bottom 20px
    .description
      font-size 18px
      padding 25px 0
  .next_btn_wrap
    width 100%
    display flex
    justify-content center
.plan-upload
  /deep/.el-upload__tip
    color #fff !important
.hide-upload
  /deep/.el-upload--picture-card
    display none !important
    // visibility hidden !important
    transition all 0.5s
.el-radio
  color white
</style>
<style lang="stylus" scoped>
  .yioks-switch-grey
    /deep/ .el-switch__label.is-active
      color: #13ce66 !important
    /deep/ .el-switch__label:not(.is-active)
      color: #ccc !important
  .scroll_wrap
    /deep/ .el-upload-list__item-name
      color: white !important
    /deep/ .el-upload-list
      width: 96% !important
</style>
